/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { colors, gradient, spacing } from '@chegg-ui/theme';
import styled, { css, keyframes } from 'styled-components';
import { avatarCircleContentSpace, avatarSizes, shimmerBookCoverConfig } from './shared';
export var getThemeConfig = function getThemeConfig(theme) {
  return {
    "default": function _default(theme) {
      return {
        borderRadius: theme.radius.sm,
        cardBorderSize: spacing.px4,
        color: colors.grey400,
        backgroundImage: gradient.shimmer
      };
    },
    prop: theme
  };
};
var ShimmerEffect = keyframes(["0%{background-position:0% 0%;}50%{background-position:100% 0%;}100%{background-position:0% 0%;}"]);
var ShimmerAnimation = css(["animation:", " 2.5s linear infinite;animation-iteration-count:2;@media (prefers-reduced-motion:reduce){animation:none;}"], ShimmerEffect);
export var ShimmerTitleContainer = styled.div.withConfig({
  componentId: "fg0bo0-0"
})(["height:", ";width:50%;", " ", " ", ""], function (_ref) {
  var size = _ref.size;
  return size === 'sm' ? '12px' : '18px';
}, function (_ref2) {
  var customTheme = _ref2.customTheme;
  return "\n    border-radius: ".concat(customTheme.borderRadius, ";\n    background-image: ").concat(customTheme.backgroundImage, ";\n    background-size: 400% 100%;\n  ");
}, function (_ref3) {
  var center = _ref3.center;
  return center ? "\n    margin: 0 auto;\n  " : '';
}, ShimmerAnimation);
export var ShimmerBodyContainer = styled.div.withConfig({
  componentId: "fg0bo0-1"
})(["height:12px;", " & + &{margin-top:", ";}", ""], function (_ref4) {
  var customTheme = _ref4.customTheme;
  return "\n    border-radius: ".concat(customTheme.borderRadius, ";\n    background-image: ").concat(customTheme.backgroundImage, ";\n    background-size: 400% 100%;\n  ");
}, spacing.px8, ShimmerAnimation);
export var ShimmerAvatarContainer = styled.div.withConfig({
  componentId: "fg0bo0-2"
})(["display:flex;width:", ";align-items:center;", "{margin-bottom:", ";}"], function (_ref5) {
  var $width = _ref5.$width;
  return $width;
}, ShimmerTitleContainer, function (_ref6) {
  var isSmallTitle = _ref6.isSmallTitle;
  return isSmallTitle ? "".concat(6 / 16, "rem") : spacing.px8;
});
export var ShimmerAvatarCircle = styled.div.withConfig({
  componentId: "fg0bo0-3"
})(["border-radius:100%;background-image:", ";background-size:400% 100%;", " ", ""], function (_ref7) {
  var customTheme = _ref7.customTheme;
  return customTheme.backgroundImage;
}, function (_ref8) {
  var size = _ref8.size;
  return "\n    width: ".concat(avatarSizes[size] / 16, "rem;\n    height: ").concat(avatarSizes[size] / 16, "rem;\n  ");
}, ShimmerAnimation);
export var ShimmerAvatarContent = styled.div.withConfig({
  componentId: "fg0bo0-4"
})(["", " flex:auto;"], function (_ref9) {
  var size = _ref9.size;
  return "\n    margin-left: ".concat(avatarCircleContentSpace[size], ";\n  ");
});
export var ShimmerBookCoverContainer = styled.div.withConfig({
  componentId: "fg0bo0-5"
})(["", " ", " ", ""], function (_ref10) {
  var customTheme = _ref10.customTheme;
  return "\n    border-radius: ".concat(customTheme.borderRadius, ";\n    background-image: ").concat(customTheme.backgroundImage, ";\n    background-size: 400% 100%;\n  ");
}, function (_ref11) {
  var size = _ref11.size;
  return "\n    width: ".concat(shimmerBookCoverConfig[size].width, ";\n    height: ").concat(shimmerBookCoverConfig[size].height, ";\n  ");
}, ShimmerAnimation);
export var ShimmerThumbnailCardContainer = styled.div.withConfig({
  componentId: "fg0bo0-6"
})(["", " padding:", ";width:", ";", ""], function (_ref12) {
  var customTheme = _ref12.customTheme;
  return "\n    background-image: ".concat(customTheme.backgroundImage, ";\n    background-size: 400% 100%;\n    border-radius: ").concat(customTheme.borderRadius, ";\n  ");
}, spacing.px4, function (_ref13) {
  var $width = _ref13.$width;
  return $width;
}, ShimmerAnimation);
export var ShimmerThumbnailCardContentWrapper = styled.div.withConfig({
  componentId: "fg0bo0-7"
})(["background-color:", ";width:100%;display:flex;border-radius:", ";", "{margin:-4px 0;}"], colors.white, function (_ref14) {
  var customTheme = _ref14.customTheme;
  return customTheme.borderRadius;
}, ShimmerBookCoverContainer);
export var ShimmerThumbnailCardContent = styled.div.withConfig({
  componentId: "fg0bo0-8"
})(["flex:auto;padding:", " ", ";", "{margin-bottom:", ";}"], spacing.px12, spacing.px16, ShimmerTitleContainer, spacing.px8);
export var ShimmerContentCardContainer = styled.div.withConfig({
  componentId: "fg0bo0-9"
})(["", " overflow:hidden;width:", ";", ""], function (_ref15) {
  var customTheme = _ref15.customTheme;
  return "\n    background-image: ".concat(customTheme.backgroundImage, ";\n    background-size: 400% 100%;\n    padding: ").concat(customTheme.cardBorderSize, ";\n    border-radius: ").concat(customTheme.borderRadius, ";\n  ");
}, function (_ref16) {
  var $width = _ref16.$width;
  return $width;
}, ShimmerAnimation);
export var ShimmerContentCardContent = styled.div.withConfig({
  componentId: "fg0bo0-10"
})(["background-color:", ";box-sizing:border-box;padding:", ";height:", "rem;", " ", "{margin-bottom:", ";}", ""], colors.white, spacing.px16, 156 / 16, function (_ref17) {
  var $media = _ref17.$media,
      customTheme = _ref17.customTheme;
  return $media ? "\n      background-image: ".concat(customTheme.backgroundImage, ";\n      background-size: 400% 100%;\n  ") : '';
}, ShimmerTitleContainer, spacing.px8, ShimmerAnimation);
export var ShimmerContentCardFooter = styled.div.withConfig({
  componentId: "fg0bo0-11"
})(["background-color:", ";", " padding:", "rem ", " ", "rem;"], colors.white, function (_ref18) {
  var customTheme = _ref18.customTheme;
  return "\n    margin-top: ".concat(customTheme.cardBorderSize, ";\n  ");
}, 5 / 16, spacing.px16, 5 / 16);
export var ShimmerSimpleCardWrapper = styled.div.withConfig({
  componentId: "fg0bo0-12"
})(["background-color:", ";"], colors.white);
export var ShimmerSimpleCardContent = styled.div.withConfig({
  componentId: "fg0bo0-13"
})(["padding:", "rem ", " ", "rem;", "{margin:0 auto ", ";}", "{margin-bottom:", ";}"], 20 / 16, spacing.px24, 24 / 16, ShimmerAvatarContainer, spacing.px24, ShimmerTitleContainer, spacing.px16);
export var ShimmerSimpleCardMedia = styled.div.withConfig({
  componentId: "fg0bo0-14"
})(["height:", "rem;background-image:", ";background-size:400% 100%;", ""], 160 / 16, function (_ref19) {
  var customTheme = _ref19.customTheme;
  return customTheme.backgroundImage;
}, ShimmerAnimation);